import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-comment",
  "use": "icon-comment-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-comment\"><path d=\"M192 810.666667h117.333333l157.013334 99.413333c27.733333 17.493333 63.573333 17.493333 91.306666 0L714.666667 810.666667h117.333333c46.933333 0 85.333333-38.4 85.333333-85.333334V213.333333c0-46.933333-38.4-85.333333-85.333333-85.333333h-640c-46.933333 0-85.333333 38.4-85.333333 85.333333v512c0 46.933333 38.4 85.333333 85.333333 85.333334z\" p-id=\"1774\" /><path d=\"M334.933333 426.666667a177.066667 177.066667 0 0 0 354.133334 0 27.733333 27.733333 0 1 0-55.466667 0 121.6 121.6 0 0 1-243.2 0 27.733333 27.733333 0 0 0-55.466667 0z\" p-id=\"1775\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/comment.svg
// module id = SdtW
// module chunks = 27